export default __webpack_public_path__ + "static/media/FT3.3610ba68.png";